// Per-type notification picker: `kinds` null = all types; otherwise only the listed kinds are sent.
export function NotifyKindChips({ id, kinds, options, canEdit, onChange, sourceNote }) {
  const chip = (on, extra = "") => `text-[9px] font-mono uppercase tracking-widest border px-1.5 py-0.5 transition-colors disabled:cursor-default ${on ? extra : "border-border text-muted-foreground hover:border-black"}`;
  return (
    <div className="flex flex-wrap gap-1 items-center" data-testid={`notify-kinds-${id}`}>
      <button type="button" data-testid={`notify-kind-all-${id}`} disabled={!canEdit} onClick={() => onChange(null)} className={chip(!kinds, "border-black bg-black text-white")}>All types</button>
      {(options || []).map((k) => {
        const on = !!kinds?.includes(k.kind);
        return <button type="button" key={k.kind} data-testid={`notify-kind-toggle-${id}-${k.kind}`} disabled={!canEdit} title={k.label}
          onClick={() => { const cur = kinds || []; const next = on ? cur.filter((x) => x !== k.kind) : [...cur, k.kind]; onChange(next.length ? next : null); }}
          className={chip(on, "border-emerald-700 bg-emerald-50 text-emerald-800")}>{k.label.replace(" (button)", "")}</button>;
      })}
      {sourceNote && <span className="text-[9px] text-muted-foreground">{sourceNote}</span>}
    </div>
  );
}
